export default  {	
	data () {
		return { 
			dataNuevo: 'pruebas'
		}
	},
	created () { 
		this.updateCrud({state:'namePath', data: 'paciente_historial'}) 
	},
	methods: {
	}
}
